import React, { Fragment, useState } from 'react'
import { Typography } from '@mui/material'
import { TicketInfo } from '../../../interfaces/PickingValidate/TicketInfo'
import { StatesRoutes } from '../../../interfaces/PickingValidate/StatesRoutes'
import { PickingFinishHeader } from './PickingFinishHeader'
import { apiCall, ApiConfig } from '../../../config/api'
import { Modal } from '../../_EOS/Modal'
import { DocumentPrint } from '../../UI/DocumentPrint/DocumentPrint'
import { PickingLabelActions } from './PickingLabelActions'
import { PickingValidateHeader } from '../../../interfaces/Picking/Picking'
import { PickingValidateFinishDetail } from './PickingValidateFinishDetail'
import { useSnackbar } from '../../../hooks/useSnackbar'
import { SnackBar } from '../../SnackBar/Snackbar'

interface PickingValidateFinishProps {
  ticketInfo: TicketInfo
  logo?: string
  handlePrintTicket: (ticketInfo: TicketInfo) => void
  statesRoute: StatesRoutes
  isUsingExternalCourierLabel: boolean
  isUsingInternalCourierLabel: boolean
  pickingHeader: PickingValidateHeader | undefined
  handleShowLabelButton: (value: boolean) => void
  executeGetLabelCourier: boolean
  sethasMultipleUnvalidatedRoutes: React.Dispatch<React.SetStateAction<boolean>>
}

export const PickingValidateFinish: React.FC<PickingValidateFinishProps> = ({
  ticketInfo,
  statesRoute,
  isUsingExternalCourierLabel,
  isUsingInternalCourierLabel,
  pickingHeader,
  handleShowLabelButton,
  executeGetLabelCourier,
  sethasMultipleUnvalidatedRoutes
}) => {
  const [isLoadingPrint, setIsLoadingPrint] = useState<boolean>(false)
  const [isModalPrintOpen, setIsModalPrintOpen] = useState<boolean>(false)
  const [documentPDF, setDocumentPDF] = useState<string>('')
  const [titleModal, setTitleModal] = useState<string>('')
  const { isActive, isSuccess, message, openSnackBar } = useSnackbar()

  const notify = (message: string, status: boolean) => {
    openSnackBar(message, status)
  }

  const handlePrintDocument = (apiMethod: string) => {
    setIsLoadingPrint(true)
    apiCall(
      'GET',
      `${ApiConfig.PickingRouteValidationApi}/${apiMethod}/${ticketInfo.pickingRouteId}`
    )
      .then((response) => {
        if (response.status === 200 && response.data !== null) {
          setDocumentPDF(response.data)
          showModalPrint(true)
        }
      })
      .catch((error) => {
        const msg =
          'Error en carga de datos: ' +
          (error.response?.data?.message || 'falla en el servicio.')
        notify(msg, false)
      })
      .finally(() => setIsLoadingPrint(false))

    if (apiMethod === 'GetValidationReport') {
      setTitleModal(`Informe Ruta Picking N° ${ticketInfo.pickingRouteId}`)
    } else {
      setTitleModal(`Etiqueta N° ${ticketInfo.pickingRouteId}`)
    }
  }

  const showModalPrint = (isVisible: boolean) => {
    setIsModalPrintOpen(isVisible)
  }

  const handleCloseShowModalPrint = () => {
    setIsModalPrintOpen(false)
    setDocumentPDF('')
  }

  return (
    <Fragment>
      <Typography variant='h4' component='h2' gutterBottom>
        {`VALIDACIÓN - `}
        <h4
          style={{
            display: 'contents',
            fontWeight: 'bold',
            color: pickingHeader?.orderCancellationRequest
              ? 'red'
              : statesRoute.colorValidationStatus
          }}
        >
          {pickingHeader?.orderCancellationRequest
            ? 'CANCELADA'
            : statesRoute.validationFinished
            ? ` TERMINADA`
            : ` NO INICIADA`}
        </h4>
      </Typography>

      <PickingFinishHeader
        ticketInfo={ticketInfo}
        statesRoute={statesRoute}
        pickingHeader={pickingHeader}
      />

      {!pickingHeader?.orderCancellationRequest &&
        statesRoute.validationFinished && (
          <PickingLabelActions
            sethasMultipleUnvalidatedRoutes={sethasMultipleUnvalidatedRoutes}
            handlePrintDocument={handlePrintDocument}
            isPrintLabelVisible={statesRoute.validationFinished}
            showModalPrint={() => showModalPrint(true)}
            workOrderId={ticketInfo.workOrderId}
            isUsingExternalCourierLabel={isUsingExternalCourierLabel}
            isUsingInternalCourierLabel={isUsingInternalCourierLabel}
            pickingHeader={pickingHeader}
            handleSnackbar={openSnackBar}
            handleShowLabelButton={handleShowLabelButton}
            executeGetLabelCourier={executeGetLabelCourier}
          />
        )}

      {statesRoute.validationFinished && (
        <PickingValidateFinishDetail
          pickingRouteId={pickingHeader?.pickingRouteId}
        />
      )}

      <Modal
        title={titleModal}
        onClose={handleCloseShowModalPrint}
        open={isModalPrintOpen}
        maxWidth='lg'
        loading={isLoadingPrint}
      >
        <DocumentPrint documentPDF={documentPDF} type='base64' />
      </Modal>

      {/* SNACKBAR */}
      <SnackBar
        message={message}
        open={isActive}
        status={isSuccess ? 'success' : 'error'}
      />
    </Fragment>
  )
}
